import React from 'react';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import TabbedPage from '../components/TabbedPage';
import useExpenseData from '../components/ExpenseComps/useExpenseData';
import DailyExpensesPage, { DAILY_CONFIG } from './DailyExpensesPage';
import ShootExpensesPage, { SHOOT_CONFIG } from './ShootExpensesPage';
import PaymentHistoryPage from './PaymentHistoryPage';
import OtherExpensesPage, { OTHER_CONFIG } from './OtherExpensesPage';

// Daily, shoot and other expenses are one subject with three ledgers (plus a payment history for the shoot payments), so they share a screen
// instead of three sidebar rows. Each ledger's data is held here so it survives a tab switch.
export default function ExpensesPage() {
    const daily = useExpenseData(DAILY_CONFIG);
    const shoot = useExpenseData(SHOOT_CONFIG);
    const other = useExpenseData(OTHER_CONFIG);

    const tabs = [
        { key: 'daily', label: 'Daily Expenses', icon: ReceiptLongRoundedIcon, module: 'expenses-daily', render: () => <DailyExpensesPage data={daily} /> },
        { key: 'shoot', label: 'Shoot Expenses', icon: VideocamRoundedIcon, module: 'expenses-shoot', render: () => <ShootExpensesPage data={shoot} /> },
        { key: 'other', label: 'Other Expenses', icon: CategoryRoundedIcon, module: 'expenses-other', render: () => <OtherExpensesPage data={other} /> },
        { key: 'payments', label: 'Payment History', icon: HistoryRoundedIcon, module: 'expenses-shoot', render: () => <PaymentHistoryPage data={shoot} config={SHOOT_CONFIG} /> },
    ];
    return <TabbedPage tabs={tabs} />;
}
